import {useState, useEffect} from "react";

// Hook: 返回当前是否为移动端（屏幕宽度 <= 768）
export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.innerWidth <= 768 || window.innerHeight > window.innerWidth;
    });

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener("resize", handleResize);

        // 清理
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return isMobile;
};
export default useIsMobile;
